import { SeguroCodeudorEdit } from "../../models/seguroCodeudorEdit";
import React, { useEffect, useState } from 'react';
import { useForm, UseFormSetValue } from 'react-hook-form';
import { yupResolver } from "@hookform/resolvers/yup";
import * as Yup from "yup";
import { CalcularMontosDto } from '../../models/participantes';
import { useParticipantes } from '../../hooks/useParticipantes';

import InputSelect from '../../../../components/inputs/yup/materialui/inputSelect';
import InputNumber from '../../../../components/inputs/yup/materialui/inputNumber';
import InputText from '../../../../components/inputs/yup/materialui/inputText';
import ConfirmationModal from "../../../../components/ui/materialui/confirmationModal";

import SaveAltIcon from '@mui/icons-material/SaveAlt';
import CloseIcon from '@mui/icons-material/Close';

import { Dominios, enumTipoParticipanteConValores, enumTipoSeguroConValores, TipoFuncionalidad, TipoSeguro } from '../../../../utils/enums';
import ModalPrimaCobertura from './modalPrimaCobertura';
import { useCodeudor } from '../../hooks/useCodeudor';
import { useToast } from '../../../../hooks/useToast';
import { SeguroCodeudor } from "../../models/seguroCodeudor";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import Grid2 from "@mui/material/Grid2";
import MButton from "../../../../components/inputs/yup/materialui/mButton";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import DialogActions from "@mui/material/DialogActions";
import { useOperacion } from "../../hooks/useOperacion";
import { DetalleMutuoPermissionGuard } from "../../../../components/auth/DetalleMutuoPermissionGuard";

interface IProps {
    seguroCodeudorSeleccionado: SeguroCodeudorEdit | undefined;
    porcentajedeudaseguro: number;
    mutuoId: number;
    rutCodeudor: string;
    esNuevoSeguro: boolean;
    show: boolean;
    setShow: React.Dispatch<React.SetStateAction<boolean>>;
    onHide: () => void;
    esVigente?: boolean;
}

const ModalSeguroCodeudor: React.FC<IProps> = (props) => {

    const { getSeguroParticipante, calcularMonto } = useParticipantes();

    const { obtenerTiposSeguros, tiposSegurosCodeudorSelect,
        obtenerPolizas, polizasSelect, setPolizasSelect,
        obtenerPolizasInternas, polizasInternasSelect, setPolizasInternasSelect,
        actualizarSeguroCodeudor, seguroCodeudorDefaultValues,
        crearSeguroCodeudor, obtenerOperacion, operacion,
        obtenerSegurosCodeudor, obtenerMontoAsegurado, montoAseguradoCalculado } = useCodeudor();

    const [show, setShow] = useState<boolean>(false);
    const [isSubmitting, setIsSubmitting] = useState<boolean>(false);
    const [creandoNuevoSeguro, setCreandoNuevoSeguro] = useState<boolean>(props.esNuevoSeguro);
    const [segurosCache, setSegurosCache] = useState<SeguroCodeudor[]>([]);
    const { addToast } = useToast();

    const [modalConfirmacion, setModalConfirmacion] = useState({
        show: false,
        title: '',
        message: '',
        metodo: () => {
        },
    });

    const schemaSeguroCodeudorEdit = Yup.object<SeguroCodeudorEdit>().shape({

        mutuoId: Yup.number().required(),

        rut: Yup.string().required(),

        tipoSeguro: Yup.string().required("Campo requerido")
            .test({
                name: 'valida-tipo-seguro-unico',
                exclusive: false,
                params: {},
                message: 'Tipo de seguro ya asignado',
                test: async (tipoSeguroSeleccionado,{createError}) => {

                    if (!props.esNuevoSeguro) {
                        return true;
                    }

                    if (segurosCache.length == 0) {

                        let seguros: SeguroCodeudor[] = await obtenerSegurosCodeudor(props.mutuoId,
                            props.rutCodeudor);

                        setSegurosCache(seguros);
                    }


                    if (tipoSeguroSeleccionado === enumTipoSeguroConValores.CESANTIA.toString()) {                      

                        let respuesta = segurosCache.some(x => x.tieneCuotaMinima === false)
                        if (respuesta) {
                            return createError({ message: "Debe ingresar la tabla de desarrollo cuota minima para el seguro cesantía" })
                        }
                    }


                    let existeTipoSeguroRepetido: boolean = segurosCache
                        .some(x => x.tipoSeguro === tipoSeguroSeleccionado);

                    return !existeTipoSeguroRepetido;
                }
            }),

        codigoPoliza: Yup.string().required("Campo requerido"),

        codigoInternoPoliza: Yup.string().required("Campo requerido"),

        tienePrima: Yup.boolean().required("Campo requerido"),

        tasa: Yup.number().required("Campo requerido")
            .min(0, "Tasa debe estar entre 0 y 100")
            .max(100, "Tasa debe estar entre 0 y 100"),

        montoPrimaAnual: Yup.number().required("Campo requerido"),

        montoAsegurado: Yup.number().required("Campo requerido"),

        montoPrimaDividendo: Yup.number().required("Campo requerido"),

        mesesGratuidad: Yup.number()
            .nullable("Campo requerido")
            .transform((value) => Number.isNaN(value) ? 0 : value),

        companiaSeguros: Yup.string().nullable("Campo requerido")
            .max(50, "Máximo 50 caractéres")
        ,
        descripcionSeguro: Yup.string().nullable("Campo requerido")
            .max(50, "Máximo 50 caractéres"),
        tipoSubsidio: Yup.string().nullable(),

    });

    const {
        formState: { errors, isDirty, isValid },
        handleSubmit,
        control,
        setValue,
        trigger,
        watch,
        reset
    } = useForm<SeguroCodeudorEdit>({
        defaultValues: props.esNuevoSeguro ? seguroCodeudorDefaultValues : props.seguroCodeudorSeleccionado,
        mode: "onChange",
        resolver: yupResolver(schemaSeguroCodeudorEdit)
    })
    const { listaTipoSubsidio, tipoSubsidios } = useOperacion();
    const dataFormSeguroCodeudor = watch();

    useEffect(() => {

        trigger();

        obtenerTiposSeguros(Dominios.TIPO_SEGURO);
        listaTipoSubsidio();

        if (!props.esNuevoSeguro) {
            obtenerPolizas(props.seguroCodeudorSeleccionado!.tipoSeguro);

            if (props.seguroCodeudorSeleccionado?.codigoPoliza != null) {
                obtenerPolizasInternas(props.seguroCodeudorSeleccionado?.codigoPoliza, props.seguroCodeudorSeleccionado.tipoSeguro);
            }

            reset(props.seguroCodeudorSeleccionado);
        }
        else {

            obtenerOperacion(props.mutuoId);

        }

        setValue("mutuoId", props.mutuoId);
        setValue("rut", props.rutCodeudor);



    }, [props.seguroCodeudorSeleccionado, reset])

    useEffect(() => {

        if (montoAseguradoCalculado) {
            setValue("montoAsegurado", montoAseguradoCalculado);
        }

    }, [montoAseguradoCalculado]);

    const handleTipoSeguro = (value: string) => {

        if (value) {
            obtenerPolizas(value);
            obtenerMontoAsegurado(dataFormSeguroCodeudor.mutuoId, value);
        }
        else {
            setPolizasSelect([]);
            setPolizasInternasSelect([]);
        }

        setValue("codigoPoliza", "");
        setValue("codigoInternoPoliza", "");

        trigger("codigoPoliza");
        trigger("codigoInternoPoliza");

        resetDatosSeguro(setValue);
    }

    const handleCodigoPoliza = (codigoPoliza: string) => {

        if (codigoPoliza)
            obtenerPolizasInternas(codigoPoliza, dataFormSeguroCodeudor.tipoSeguro);
        else {
            setPolizasInternasSelect([]);
        }

        setValue("codigoInternoPoliza", "");
        trigger("codigoInternoPoliza");
        resetDatosSeguro(setValue);
    }

    const handleCodigoInternoPoliza = async (codigoInternoPolizaSeleccionado: string) => {

        resetDatosSeguro(setValue);

        const resp = await getSeguroParticipante(dataFormSeguroCodeudor.codigoPoliza!, codigoInternoPolizaSeleccionado);

        if (resp) {
            setValue("tasa", resp.tasa!);
            setValue("companiaSeguros", resp.nombreCompania);
            setValue("descripcionSeguro", resp.descripcionSeguro);
            setValue("tienePrima", resp.tienePrima!);
        }
    }


    const handleCalcularMonto = async () => {

        let data: CalcularMontosDto = {
            tipoParticipante: enumTipoParticipanteConValores.Codeudor,
            idMutuo: dataFormSeguroCodeudor.mutuoId,
            codigoPoliza: dataFormSeguroCodeudor.codigoPoliza ?? '',
            codigoHijo: dataFormSeguroCodeudor.codigoInternoPoliza ?? '',
            porcentajeDeudaSeguro: props.porcentajedeudaseguro ?? 0,
            tasaCalcular: dataFormSeguroCodeudor.tasa ?? 0,
            montoAsegurado: dataFormSeguroCodeudor.montoAsegurado ?? 0,
            montoCredito: dataFormSeguroCodeudor.montoAsegurado ?? 0
        }

        const resp = await calcularMonto(data);
        if (resp) {
            setValue("montoPrimaDividendo", resp.montoPrima);
            setValue("montoPrimaAnual", resp.montoPrimaAnual);
        }
    }

    const handleCancelarEdicionClick = () => {

        if (isDirty) {
            setModalConfirmacion({
                show: true,
                title: "Hay cambios sin guardar",
                message: "¿Desea abandonar la edición?",
                metodo: () => {
                    props.onHide();
                    reset();
                },
            });
        }
        else {
            props.onHide();
            reset();
        }

    }

    useEffect(() => {

        handleCalcularMonto();

    }, [dataFormSeguroCodeudor.montoAsegurado, dataFormSeguroCodeudor.tasa]);

    const onSubmit = async (data: SeguroCodeudorEdit) => {

        setIsSubmitting(true);

        try {

            await actualizarSeguroCodeudor(data);

            addToast({
                mostrar: true,
                titulo: 'Confirmación',
                tipo: 'Success',
                mensaje: 'Datos modificados correctamente'
            });

            setIsSubmitting(false);

            props.onHide();
        }
        catch (error) {
            console.log(error);
            setIsSubmitting(false);
        }
    };

    const onSubmitNuevo = async (data: SeguroCodeudorEdit) => {

        setIsSubmitting(true);

        try {

            await crearSeguroCodeudor(data);

            addToast({
                mostrar: true,
                titulo: 'Confirmación',
                tipo: 'Success',
                mensaje: 'Seguro creado correctamente'
            });

            setIsSubmitting(false);
            setCreandoNuevoSeguro(false);

            props.onHide();
        }
        catch (error) {
            console.log(error);
            setIsSubmitting(false);
        };
    };

    function customOnHide() {
        props.onHide()
    }

    return (
        <>
            <ConfirmationModal
                onHide={() =>
                    setModalConfirmacion({
                        ...modalConfirmacion,
                        show: false,
                    })
                }
                onConfirm={modalConfirmacion.metodo}
                show={modalConfirmacion.show}
                title={modalConfirmacion.title}
                message={modalConfirmacion.message}
            />

            <Dialog open={props.show} onClose={customOnHide} maxWidth="lg">
                <DialogTitle>Seguro Codeudor</DialogTitle>

                <DialogContent>
                    <form onSubmit={handleSubmit(onSubmit)}>
                        <Grid2 container spacing={2}>
                            <Grid2 size={{ lg: 3, xs: 12 }}>
                                <InputSelect
                                    label="Tipo seguro"
                                    name="tipoSeguro"
                                    control={control}
                                    options={tiposSegurosCodeudorSelect}
                                    error={errors.tipoSeguro}
                                    onChange={(value) => { handleTipoSeguro(value ?? ''); }}
                                    disabled={!props.esNuevoSeguro}
                                />
                            </Grid2>

                            <Grid2 size={{ xs: 12, lg: 3 }}>
                                <InputSelect
                                    label="Código póliza"
                                    name="codigoPoliza"
                                    control={control}
                                    options={polizasSelect}
                                    onChange={(value) => handleCodigoPoliza(value ?? '')}
                                    error={errors.codigoPoliza}
                                    readonly={dataFormSeguroCodeudor.tipoSeguro === "DESGRAVAMEN" && props.esVigente && !props.esNuevoSeguro ||
                                        dataFormSeguroCodeudor.tipoSeguro === "CESANTIA" && props.esVigente && !props.esNuevoSeguro}
                                />
                            </Grid2>

                            <Grid2 size={{ xs: 12, lg: 3 }}>
                                <InputSelect
                                    label="Código interno póliza"
                                    name="codigoInternoPoliza"
                                    control={control}
                                    options={polizasInternasSelect}
                                    onChange={(codigoInternoPolizaSeleccionado) => handleCodigoInternoPoliza(codigoInternoPolizaSeleccionado ?? '')}
                                    error={errors.codigoInternoPoliza}
                                    readonly={dataFormSeguroCodeudor.tipoSeguro === "DESGRAVAMEN" && props.esVigente && !props.esNuevoSeguro ||
                                        dataFormSeguroCodeudor.tipoSeguro === "CESANTIA" && props.esVigente && !props.esNuevoSeguro}
                                />
                            </Grid2>

                            <Grid2 size={{ xs: 12, lg: 3 }}>
                                <InputNumber
                                    label="Tasa (%)"
                                    name="tasa"
                                    control={control}
                                    decimales={4}
                                    error={errors.tasa}
                                    readonly={dataFormSeguroCodeudor.tipoSeguro === "DESGRAVAMEN" && props.esVigente && !props.esNuevoSeguro ||
                                        dataFormSeguroCodeudor.tipoSeguro === "CESANTIA" && props.esVigente && !props.esNuevoSeguro}
                                />
                            </Grid2>

                            <Grid2 size={{ xs: 12, lg: 3 }}>
                                <InputNumber
                                    label="Monto prima anual (UF)"
                                    name="montoPrimaAnual"
                                    control={control}
                                    decimales={4}
                                    readonly
                                    error={errors.montoPrimaAnual}
                                    disabled={dataFormSeguroCodeudor.tipoSeguro === "DESGRAVAMEN" && props.esVigente && !props.esNuevoSeguro ||
                                        dataFormSeguroCodeudor.tipoSeguro === "CESANTIA" && props.esVigente && !props.esNuevoSeguro}
                                />
                            </Grid2>

                            <Grid2 size={{ xs: 12, lg: 3 }}>
                                <InputNumber
                                    label="Monto asegurado (UF)"
                                    name="montoAsegurado"
                                    control={control}
                                    decimales={4}
                                    readonly={dataFormSeguroCodeudor.tipoSeguro == TipoSeguro.CESANTIA.toString() ||
                                        dataFormSeguroCodeudor.tipoSeguro === "DESGRAVAMEN" && props.esVigente && !props.esNuevoSeguro ||
                                        dataFormSeguroCodeudor.tipoSeguro === "CESANTIA" && props.esVigente && !props.esNuevoSeguro}
                                    error={errors.montoAsegurado}
                                />
                            </Grid2>

                            <Grid2 size={{ xs: 12, lg: 3 }}>
                                <InputNumber
                                    label="Monto prima dividendo (UF)"
                                    name="montoPrimaDividendo"
                                    control={control}
                                    decimales={4}
                                    readonly
                                    error={errors.montoPrimaDividendo}
                                />
                            </Grid2>

                            <Grid2 size={{ xs: 12, lg: 3 }}>
                                <InputNumber
                                    label="Meses gratuidad"
                                    name="mesesGratuidad"
                                    control={control}
                                    minValue={0}
                                    decimales={0}
                                    maxValue={999}
                                    error={errors.mesesGratuidad}
                                    readonly={dataFormSeguroCodeudor.tipoSeguro === "DESGRAVAMEN" && props.esVigente && !props.esNuevoSeguro ||
                                        dataFormSeguroCodeudor.tipoSeguro === "CESANTIA" && props.esVigente && !props.esNuevoSeguro}
                                />
                            </Grid2>

                            <Grid2 size={{ xs: 12, lg: 4 }}>
                                <InputText
                                    label="Nombre compañía seguros"
                                    name="companiaSeguros"
                                    control={control}
                                    error={errors.companiaSeguros}
                                    readonly />
                            </Grid2>
                            {dataFormSeguroCodeudor.tipoSeguro === TipoSeguro.CESANTIA &&
                                (<Grid2 size={{ lg: 4, xs: 12 }}>
                                    <InputSelect
                                        label='Tipo subsidio'
                                        name="tipoSubsidio"
                                        control={control}
                                        options={tipoSubsidios}
                                        error={errors.tipoSubsidio}
                                        readonly={props.esVigente && !props.esNuevoSeguro}
                                    />
                                </Grid2>)
                            }

                            <Grid2 size={{ xs: 12, lg: 4 }}>
                                <InputText
                                    label="Descripción"
                                    name="descripcionSeguro"
                                    control={control}
                                    error={errors.descripcionSeguro}
                                    readonly />
                            </Grid2>

                            {dataFormSeguroCodeudor.tienePrima && dataFormSeguroCodeudor.codigoInternoPoliza && (
                                <Grid2 sx={{ xs: 12, md: 4 }} display="flex" alignItems="center">
                                    <MButton variant='contained' onClick={() => { setShow(true); }}>Prima por cobertura</MButton>
                                </Grid2>
                            )}
                        </Grid2>
                    </form>

                    <ModalPrimaCobertura
                        show={show}
                        onHide={() => { setShow(false); }}
                        codigo={dataFormSeguroCodeudor.codigoPoliza}
                        codigoInterno={dataFormSeguroCodeudor.codigoInternoPoliza}
                        tipoSeguro={dataFormSeguroCodeudor.tipoSeguro}
                        tienePrima={dataFormSeguroCodeudor.tienePrima}
                        montoAsegurado={dataFormSeguroCodeudor.montoAsegurado}
                    />
                </DialogContent>

                <DialogActions>
                    <DetalleMutuoPermissionGuard
                        esVigente={props.esVigente}
                        permissions={[TipoFuncionalidad.Bandeja_editar, TipoFuncionalidad.Cartera_editar_info]}>
                        <MButton
                            variant="contained"
                            color="primary"
                            disabled={!isValid}
                            onClick={creandoNuevoSeguro ? handleSubmit(onSubmitNuevo) : handleSubmit(onSubmit)}
                            startIcon={<SaveAltIcon />}
                        >
                            Guardar
                        </MButton>
                    </DetalleMutuoPermissionGuard>
                    <MButton variant="contained" color="inherit"
                        onClick={handleCancelarEdicionClick}
                        startIcon={<CloseIcon />}>Cancelar</MButton>
                </DialogActions>

            </Dialog>

        </>
    )
}

export default ModalSeguroCodeudor

function resetDatosSeguro(setValue: UseFormSetValue<SeguroCodeudorEdit>) {
    setValue("tasa", 0);
    setValue("montoPrimaAnual", 0);
    setValue("mesesGratuidad", 0);
    setValue("companiaSeguros", "");
    setValue("descripcionSeguro", "");
    setValue("montoPrimaDividendo", 0);
}